module.exports = __webpack_public_path__ + "img/top-US.35339946.png";